import React, { useEffect, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import fetchData from "verticales/FetchData";
import AppLoading from "verticales/AppLoading.tsx";
import iconAlerta from "assets/images/icons/icono_alerta.ico";
import { useNavigate } from "react-router-dom";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "informes";

function ClientesSiesa() {
  const [numeroRds, setNumeroRds] = useState(0);
  const [blocking, setBlocking] = React.useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const catData = async () => {
      setBlocking(true);
      const data = await fetchData(url, context, { action: "alerta-rds-cpu" });
      if (data?.rows?.length > 0) {
        const obj = data.rows[0];
        console.log("obj....", obj["rds_id"]);
        setNumeroRds(obj["rds_id"]);
      } else if (data?.error == 403) {
        // console.log("hola como estas!!!!!!!!!!!!!!!!");
        navigate("/login");
      }
      // console.log("data.....", data);
      // setData(resp.rows);
      setBlocking(false);
    };
    catData();
  }, []);
  return (
    <Grid item xs={12} md={6} lg={3}>
      <MDBox mb={1.5} ml={0}>
        {blocking ? (
          <AppLoading titleCustom={"Alerta RDS"} />
        ) : (
          <ComplexStatisticsCard
            color="success"
            icon={<img src={iconAlerta} />}
            title="Alerta RDS"
            count={numeroRds}
            percentage={{
              color: "success",
              amount: "1%",
              label: "Bases alertadas",
            }}
          />
        )}
      </MDBox>
    </Grid>
  );
}

export default ClientesSiesa;
